module.exports = __webpack_public_path__ + "static/media/GameAudio.faf5b605.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/audio/GameAudio.m4a
// module id = 478
// module chunks = 0